import React from "react";

import { GroupManagerProps } from "~/components/Admin/Group/useGroupManager";
import { DangerButton, SecondaryButton } from "~/components/common/buttons";
import { Toolbar } from "~/components/common/toolbars";
import Dialog from "~/components/generic/Dialog";

export interface DeleteGroupDialogProps extends GroupManagerProps {
  orgName: string;
}

export const DeleteGroupDialog = (props: DeleteGroupDialogProps) => {
  const {
    deleteVisible,
    error,
    close,
    confirmDelete,
    group,
    loading,
    orgName,
  } = props;

  const cancel = () => {
    close();
  };

  return (
    <Dialog
      isOpen={deleteVisible}
      header="Remove Group"
      onRequestClose={cancel}
      actions={
        <Toolbar>
          <SecondaryButton onClick={cancel}>Cancel</SecondaryButton>
          <DangerButton disabled={loading} onClick={confirmDelete}>
            Delete
          </DangerButton>
        </Toolbar>
      }
    >
      <div className="alert alert-warning">
        {`You are about to remove ${group?.name} from accessing ${orgName}. 
        All users belonging to this group will be impacted. Are you sure?`}
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
    </Dialog>
  );
};
